import { qrMatrix, qrSvgPath, validateReviewUrl } from "../shared/review";

/** Black-on-white QR code drawn locally as SVG, with a 4-module white quiet zone for reliable scanning. */
export function QrCode({ text, label }: { text: string; label: string }) {
  const { size, d } = qrSvgPath(qrMatrix(text), 4);
  return (
    <svg className="qr-code" viewBox={`0 0 ${size} ${size}`} role="img" aria-label={label} shapeRendering="crispEdges" xmlns="http://www.w3.org/2000/svg">
      <rect width={size} height={size} fill="#ffffff" />
      <path d={d} fill="#000000" />
    </svg>
  );
}

/** Invoice footer block. Renders nothing unless a valid review-form link is saved. */
export function ReviewFooter({ reviewUrl }: { reviewUrl?: string | null }) {
  const v = validateReviewUrl(reviewUrl ?? "");
  if (!v.ok || !v.url) return null;
  return (
    <div className="review-footer">
      <QrCode text={v.url} label="QR code: leave Wali Auto Fix a Google review" />
      <div>
        <strong>Happy with our service? Leave us a Google review.</strong>
        <div>Scan with your phone camera.</div>
      </div>
    </div>
  );
}
